module.exports = __webpack_public_path__ + "img/door-contact-lg-locked.27164484.svg";